import React from 'react';
import { Icon, Spin, StatusPill, InvPill, MarginChip, StatusDot,
         Drawer, Modal, Tabs, FG, RG } from '../components/ui.jsx';
import { api, fmt, fmtD, dayN } from '../api.js';
import { ROLES, RL, TIPOLOGIE, REGIE, STATUSES, SL, INVOICE, MAT_CAT, MONTHS,
         STATUS_COLORS, INV_COLORS } from '../constants.js';

export const CalendarPage = ({onNav}) => {
  const now = new Date();
  const [year,setYear] = React.useState(now.getFullYear());
  const [month,setMonth] = React.useState(now.getMonth()+1);
  const [projects,setProjects] = React.useState([]);
  const [selDay,setSelDay] = React.useState(null);

  React.useEffect(()=>{
    api(`/projects?month=${month}&year=${year}`).then(setProjects).catch(()=>{});
  },[month,year]);

  const prev=()=>month===1?(setMonth(12),setYear(y=>y-1)):setMonth(m=>m-1);
  const next=()=>month===12?(setMonth(1),setYear(y=>y+1)):setMonth(m=>m+1);

  const firstDay=new Date(year,month-1,1).getDay();
  const dim=new Date(year,month,0).getDate();
  const cells=[];
  for(let i=0;i<(firstDay||7)-1;i++) cells.push(null);
  for(let d=1;d<=dim;d++) cells.push(d);

  const evByDay={};
  projects.forEach(p=>{
    const s=dayN(p.date_start), e=p.date_end?dayN(p.date_end):s;
    for(let d=s;d<=e;d++){evByDay[d]=evByDay[d]||[];evByDay[d].push(p);}
  });

  const tl={Live:'var(--blue)',Remote:'#065F46','Live RTS':'#7C3AED','Live Social':'#DB2777',
    REC:'#B45309',Allestimento:'#374151',Produzione:'#1D4ED8'};
  const sc={draft:'#9CA3AF',confirmed:'var(--blue)',in_corso:'#1D4ED8',
    closed:'#6B7280',archived:'#D1D5DB'};

  const dayEvents = selDay ? (evByDay[selDay]||[]) : [];

  return(
    <div>
      <div className="page-header">
        <div className="page-title">{MONTHS[month]} {year}</div>
        <div style={{display:'flex',gap:4}}>
          <button className="btn btn-ghost" onClick={prev}>
            <Icon name="chevron-left" size={16} color="var(--n500)"/></button>
          <button className="btn btn-ghost"
            onClick={()=>{setMonth(now.getMonth()+1);setYear(now.getFullYear());setSelDay(null);}}>Oggi</button>
          <button className="btn btn-ghost" onClick={next}>
            <Icon name="chevron-right" size={16} color="var(--n500)"/></button>
        </div>
      </div>
      <div className="calendar-grid">
        {['Lun','Mar','Mer','Gio','Ven','Sab','Dom'].map(d=><div key={d} className="cal-header">{d}</div>)}
        {cells.map((d,i)=>(
          <div key={i} onClick={()=>d&&setSelDay(d===selDay?null:d)}
            className={'cal-day'
              +(d&&d===now.getDate()&&month===now.getMonth()+1&&year===now.getFullYear()?' today':'')
              +(d===selDay?' selected':'')
              +(d?'':' other-month')}
            style={d===selDay?{borderColor:'var(--blue)',background:'var(--blue-50)'}:{}}>
            {d&&<>
              <div className="cal-day-num">{d}</div>
              {(evByDay[d]||[]).slice(0,3).map(p=>(
                <div key={p.id} className="cal-event"
                  onClick={e=>{e.stopPropagation(); onNav && onNav('projects',p.id);}}
                  style={{background:tl[p.tipologia]||sc[p.status]||'var(--blue)',
                    opacity:p.status==='closed'||p.status==='archived'?.6:1,cursor:'pointer'}}
                  title={`${p.code} - ${p.client_name||''} (${SL[p.status]||p.status})`}>
                  {p.title}
                </div>
              ))}
              {(evByDay[d]||[]).length>3&&
                <div style={{fontSize:9,color:'var(--n400)',textAlign:'center'}}>+{evByDay[d].length-3}</div>}
            </>}
          </div>
        ))}
      </div>

      {/* Day detail panel */}
      {selDay && dayEvents.length > 0 && (
        <div className="card" style={{marginTop:14,padding:'16px 20px'}}>
          <div className="card-title" style={{marginBottom:10}}>
            <Icon name="calendar" size={12} color="var(--n400)"/>
            {selDay} {MONTHS[month]} {year} — {dayEvents.length} cantier{dayEvents.length===1?'e':'i'}
          </div>
          {dayEvents.map(p=>(
            <div key={p.id} className="crew-slot" style={{cursor:'pointer',marginBottom:6}}
              onClick={()=>onNav && onNav('projects',p.id)}>
              <div style={{flex:1}}>
                <div style={{display:'flex',alignItems:'center',gap:8}}>
                  <span style={{color:'var(--blue)',fontSize:12,fontWeight:700}}>{p.code}</span>
                  <span style={{fontWeight:600,fontSize:13}}>{p.title}</span>
                  <StatusPill val={p.status}/>
                </div>
                <div style={{fontSize:11,color:'var(--n400)',marginTop:3,display:'flex',gap:12}}>
                  {p.client_name && <span><Icon name="building" size={10} color="var(--n300)" style={{marginRight:3}}/>{p.client_name}</span>}
                  {p.tipologia && <span>{p.tipologia}</span>}
                  {p.location && <span><Icon name="map-pin" size={10} color="var(--n300)" style={{marginRight:3}}/>{p.location}</span>}
                  {p.manager_name && <span><Icon name="user" size={10} color="var(--n300)" style={{marginRight:3}}/>{p.manager_name}</span>}
                </div>
              </div>
              <Icon name="chevron-right" size={14} color="var(--n400)"/>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
